const questionTypes = {
  url: 'URL',
  task: 'Task/Question',
  range: 'Rating Scale',
  written: 'Written Response',
  multiple_select: 'Multiple Selection (pick any)',
  single_select: 'Single Selection (pick one)',
  image_select: 'Image',
  audio_video: 'Video or Audio',
  ranking: 'Ranking',
};

/**
 * Questions that contain some kind of media to be displayed
 * image_select questions should use image_url
 * audio_video questions should use video_url
 */
export const mediaQuestions = ['image_select', 'audio_video'];

export default questionTypes;
